import React, { Fragment, useState, useEffect, useRef, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { groupBy, orderBy, uniqBy, isEmpty, pick, get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, useCounter, } from 'react-use';
import { toast, } from 'react-toastify';
import { Link, } from 'react-router-dom';
import Select from 'react-select';
import jsbarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import { addHours, } from 'date-fns';
import classnames from 'classnames';
import { PDFDocument, } from 'pdf-lib';
import fileDownload from 'js-file-download';
import dedent from 'dedent';
import DatePicker from 'react-datepicker';

import env from '../../env';
import firebase, { functions } from '../../firebase';
import { isMobile, safePrefix, } from '../../util';
import { drawProductLabel, drawProductLabels40, drawAmazonProductLabel } from '../../label';
import { fieldDisplayValue, } from '../../shared/util';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import { newId } from '../../util';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { batch, } from '../../shared/firebase';
import { boxSizes, } from '../../shared/config';
import { idWithTenant, } from '../../shared/util';
import { fields, setSizes, } from '../../shared/models/receivingRequest';
import { labelString, nekoToggleValues, } from '../../shared/models/product';
import ReceivingRequestDetailModal from './ReceivingRequestDetailModal';
import ReceivingRequestFormModal from './ReceivingRequestFormModal';
import ListForm from '../ListForm';
import UnknownReceivingRequestFormModal from '../modals/UnknownReceivingRequestFormModal';
import UnknownLabelModal from '../modals/UnknownLabelModal';
import PendingItemForm from '../forms/PendingItemForm';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import ProgressButton from '../ProgressButton';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useCollectionFetch from '../hooks/useCollectionFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import useCollectionsFetch from '../hooks/useCollectionsFetch';

const labelWidth = 52.5;
const labelHeight = 29.7;
const { keys, entries, } = Object;
const printBarcode = functions.httpsCallable('printBarcode');
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const billingLogsRef = db.collection('billingLogs');
const inventoriesRef = db.collection('inventories');
const receivingRequestsRef = db.collectionGroup('receivingRequests');
const receivingRequestDocumentNumberGroupsRef = db.collectionGroup('receivingRequestDocumentNumberGroups');
const tenantsRef = db.collection('tenants');
const printersRef = db.collection('printers');
const setSizeOptions = entries(setSizes).map(([k, v]) => ({ label: v.label, value: k, }));
const shippingSizeOptions = entries(boxSizes).map(([k, v]) => ({ label: v.label, value: k, }));

export default function ReceivementFormModal(props) {
  const { isOpen, tenants, locations, } = props;
  const tenantsById = keyBy(tenants, 'id');

  const barcodeValueInput = useRef(null);
  const [version, { inc: updateVersion }] = useCounter(0);

  // DEV
  // const [tenantNumber, setTenantNumber] = useState('1');
  const [tenantNumber, setTenantNumber] = useState('');
  const [expirationDate, setExpirationDate] = useState(null);

  const [barcodeValue, setBarcodeValue] = useState('');
  const [files, setFiles] = useState(null);
  const isFnskuBarcode = !!barcodeValue.match(/^X[^-]+$/);
  const isProductIdBarcode = barcodeValue.match(new RegExp(`^(${env('TENANT_PREFIX')})?[^-]+-\\d+`));
  const documentNumber = !barcodeValue.match(new RegExp(`^(${env('TENANT_PREFIX')})?[^-]+-\\d+`)) && barcodeValue;
  const [receivingRequestNumber, setReceivingRequestNumber] = useState('');
  const [productBarcodeInfoValue, setProductBarcodeInfoValue] = useState('');
  const [isPrinting, togglePrinting] = useToggle(false);
  const [showsUnknownShelvingModal, toggleUnknownShelvingModal] = useToggle(false);
  const [unknownReceivingRequest, setUnknownReceivingRequest] = useState(null);
  const [isNg, toggleNg] = useToggle(false);
  const [hasPrintedBarcode, togglePrintedBarcode] = useToggle(false);
  const [setSize, setSetSize] = useState('none');
  const [isOpp, toggleOpp] = useToggle(false);
  const [quantity, setQuantity] = useState(1);
  const [quantityOfSet, setQuantityOfSet] = useState(1);

  // DEV
  // const [selectedProductFullId, selectProductFullId] = useState('LGP1-13');
  const [selectedProductFullId, selectProductFullId] = useState(null);

  const tenantId = tenantNumber && env('TENANT_PREFIX') + tenantNumber;
  const receivingRequestId = receivingRequestNumber && 'W' + receivingRequestNumber;
  const printers = useCollectionSubscription(printersRef.orderBy('createdAt'));
  const printersById = keyBy(printers, 'id');
  const printerOptions = [{ label: '(規定プリンター)', value: null }, ...printers.map(_ => ({ label: _.name, value: _.id }))];
  const [currentPrinterId, selectPrinterId] = useState(null);
  const [shippingSize, selectShippingSize] = useState(null);
  const receivingRequestDocumentNumberGroups = useCollectionSubscription(receivingRequestDocumentNumberGroupsRef);
  const receivingRequestDocumentNumbers = receivingRequestDocumentNumberGroups.flatMap(_ => entries(omit(_, ['id', 'ref'])).filter(_ => _[1]).map(([receivingRequestId, documentNumber]) => ({ tenantId: _.ref.parent.parent.id, receivingRequestId, documentNumber })));
  const documentNumberMatchedReceivingRequests = useDocumentsFetch(documentNumber?.length >= 5 && receivingRequestDocumentNumbers.filter(_ => _.documentNumber?.match(documentNumber)).map(_ => tenantsRef.doc(_.tenantId).collection('receivingRequests').doc(_.receivingRequestId)), [documentNumber, version]);
  const filteredDocumentNumberMatchedReceivingRequests = documentNumberMatchedReceivingRequests.filter(_ => ['initial', 'resubmitted', 'processing'].includes(_.status));

  const tenant = useDocumentSubscription(tenantId && tenantsRef.doc(tenantId), [tenantId]);
  const tenantReceivingRequests = useCollectionFetch(tenantId && tenantsRef.doc(tenantId).collection('receivingRequests').where('status', 'in', ['initial', 'resubmitted', 'processing']), [tenantId, version]);
  const janMatchedProducts = useCollectionFetch(!isFnskuBarcode && !isProductIdBarcode && barcodeValue && db.collectionGroup('products').where('barcodeInfo', '==', barcodeValue), [version, barcodeValue]);
  const inputtedDocumentNumber = janMatchedProducts.length === 0 && documentNumber;
  const isNotFoundDocumentNumber = !!inputtedDocumentNumber && documentNumberMatchedReceivingRequests.length === 0;
  const idMatchedReceivingRequests = tenantReceivingRequests
    .filter(_ => receivingRequestId ? _.id === receivingRequestId : true)
    .filter(_ => isNotFoundDocumentNumber ? isEmpty(_.documentNumber) : true);
  const fnskuMatchedProducts = useCollectionFetch(isFnskuBarcode && db.collectionGroup('products').where('fnsku', '==', barcodeValue), [version, barcodeValue]);
  const productIdMatchedProducts = useDocumentsFetch(isProductIdBarcode ? (
      [tenantsRef.doc(safePrefix(barcodeValue).match(new RegExp(`^(${env('TENANT_PREFIX')}[^-]+)`))[1]).collection('products').doc(safePrefix(barcodeValue).replace(new RegExp(`^${env('TENANT_PREFIX')}[^-]+-`), ''))]
    ) : [],
    [version, barcodeValue]
  );
  const janMatchedReceivingRequests = useCollectionsFetch(janMatchedProducts.length > 0 ? janMatchedProducts.map(_ => _.ref.parent.parent.collection('receivingRequests').where('productIds', 'array-contains', _.id)) : [], [janMatchedProducts]);
  const fnskuMatchedReceivingRequests = useCollectionsFetch(isFnskuBarcode ? fnskuMatchedProducts.map(_ => _.ref.parent.parent.collection('receivingRequests').where('productIds', 'array-contains', _.id)) : [], [fnskuMatchedProducts]);
  const candidateReceivingRequests = (janMatchedProducts.length > 0 ? (
    uniqBy(janMatchedReceivingRequests.filter(_ => ['initial', 'resubmitted', 'processing'].includes(_.status)), _ => idWithTenant(_.ref))
  ) : isFnskuBarcode ? (
    uniqBy(fnskuMatchedReceivingRequests.filter(_ => ['initial', 'resubmitted', 'processing'].includes(_.status)), _ => idWithTenant(_.ref))
  ) : filteredDocumentNumberMatchedReceivingRequests.length > 0 ? (
    filteredDocumentNumberMatchedReceivingRequests
  ) : idMatchedReceivingRequests).filter(_ => _.items != null);
  const candidateReceivingRequestProducts = useDocumentsFetch(!janMatchedProducts.length && !isFnskuBarcode && !isProductIdBarcode && uniqBy(candidateReceivingRequests.map(rr => rr.productIds.map(_ => rr.ref.parent.parent.collection('products').doc(_))) .flat() , 'id'), [version, barcodeValue, documentNumberMatchedReceivingRequests, tenantReceivingRequests, receivingRequestId]);
  const products = janMatchedProducts.length > 0 ? (
    janMatchedProducts
  ) : isFnskuBarcode ? (
    fnskuMatchedProducts
  ) : isProductIdBarcode ? (
    productIdMatchedProducts
  ) : candidateReceivingRequestProducts;
  const productsByFullId = keyBy(products, _ => idWithTenant(_.ref));
  const candidateReceivingRequestItems = candidateReceivingRequests
    .flatMap(rr => rr.items.map(_ => ({ ..._, receivingRequest: rr })))
    .map((item) => {
      const { productId, quantity, receivingRequest, } = item;
      const receivedCount = (receivingRequest[`goodReceivedInventoryIds-${productId}`] || []).length + (receivingRequest[`ngReceivedInventoryIds-${productId}`] || []).length;
      const unreceivedCount = quantity - receivedCount;
      const isAllReceived = receivedCount >= quantity;
      return {
        ...item,
        receivedCount,
        unreceivedCount,
        isAllReceived,
      };
    });
  const selectedProduct = productsByFullId[selectedProductFullId];
  const productOptions = orderBy(products.map((product) => {
    const { id, ref, sku, name, } = product;
    const isAllReceived = candidateReceivingRequestItems.filter(_ => _.productId === id).every(_ => _.isAllReceived);
    return {
      value: idWithTenant(ref),
      id: idWithTenant(ref),
      productId: id,
      sku,
      name,
      isAllReceived,
      label: (
        <ProductSelectOptionLabel admin product={product} style={isAllReceived ? { opacity: 0.3, } : null} />
      )
    };
  }), ['isAllReceived', _ => parseInt(_.productId, 10)]);
  const barcodeMatcedProduct = products.find(_ => !isEmpty(productBarcodeInfoValue) && _.barcodeInfo === productBarcodeInfoValue);
  const fetchedConclusiveProduct = barcodeMatcedProduct || selectedProduct;
  // NOTE: ネコポス指定等の変更を即時反映するため、確定した商品のみ購読する(1件)
  const subscribedConclusiveProduct = useDocumentSubscription(fetchedConclusiveProduct?.ref, [fetchedConclusiveProduct && idWithTenant(fetchedConclusiveProduct.ref)]);
  const conclusiveProduct = fetchedConclusiveProduct && { ...fetchedConclusiveProduct, ...subscribedConclusiveProduct };
  const productMatchedReceivingRequests = candidateReceivingRequests.filter((receivingRequest) => {
    const { items } = receivingRequest;
    const targetItem = candidateReceivingRequestItems.find(_ => _.receivingRequest === receivingRequest && _.productId === get(conclusiveProduct, 'id'));
    return targetItem && !targetItem.isAllReceived;
  });
  const conclusiveReceivingRequests = conclusiveProduct != null ? productMatchedReceivingRequests : candidateReceivingRequests;
  const onClickPrintBarcode = async (ng = false) => {
    togglePrinting(true);
    toggleNg(ng);
    try {
      const canvas = document.createElement('canvas');
      if(conclusiveProduct.isAmazonProduct && conclusiveProduct.fnsku && !ng) {
        drawAmazonProductLabel(canvas, labelWidth, labelHeight, conclusiveProduct, ng);
      } else {
        if(ng) {
          drawProductLabel(canvas, labelWidth, labelHeight, conclusiveProduct, ng);
        } else {
          const scale = 10;
          canvas.width = scale * 52.5;
          canvas.height = scale * 29.7;
          drawProductLabels40(canvas, [{ product: conclusiveProduct }], scale, 'id');
        }
      }
      const imageData = canvas.toDataURL('image/jpeg', 0.2);
      const doc = new jsPDF({
        orientation: 'landscape',
        format: [labelWidth, labelHeight]
      });
      doc.addImage(imageData, 'JPEG', 0, 0, labelWidth, labelHeight);
      const pdfData = doc.output('datauri');
      const allPdfDoc = await PDFDocument.create();
      const pdfDoc = await PDFDocument.load(pdfData);
      await Array(quantity).fill().reduce(async (x, _, i) => {
        await x;

        const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
        await allPdfDoc.addPage(page);
      }, Promise.resolve());

      const content = await allPdfDoc.saveAsBase64({ dataUri: true })
      // DEV
      // fileDownload(await allPdfDoc.save(), 'hoge.pdf');
      // return;

      await printBarcode({
        type: 'receivementProduct',
        title: labelString(conclusiveProduct),
        imageData: content,
        printnodePrinterId: printersById[currentPrinterId]?.printnodePrinterId,
      });
      togglePrintedBarcode(true);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
    togglePrinting(false);
  };
  const newUnknownReceivingRequestRef = async (values) => {
    const receivingRequestsRef = tenantsRef.doc(values.tenantId).collection('receivingRequests');
    const { docs: [lastReceivingRequestDoc] } = await receivingRequestsRef.orderBy('createdAt', 'desc').limit(1).get();
    return receivingRequestsRef.doc('W' + newId(lastReceivingRequestDoc));
  };
  const onClickNeko = async () => {
    const values = nekoToggleValues(conclusiveProduct);
    const suffix = ({ true: 'に指定', false: '指定を解除' })[values.isNeko];
    if(!window.confirm(`本当にネコポス${suffix}しますか？`)) return;

    await conclusiveProduct.ref.update(values);
    updateVersion();
    toast.success(`ネコポス${suffix}しました`);
  };
  useEffect(() => {
    if(janMatchedProducts.length > 0 || isFnskuBarcode || isProductIdBarcode) {
      togglePrintedBarcode(true);
    } else {
      togglePrintedBarcode(false);
    }
    if(janMatchedProducts.length > 0) {
      selectProductFullId(idWithTenant(janMatchedProducts[0].ref));
      setTenantNumber(janMatchedProducts[0].ref.parent.parent.id.replace(env('TENANT_PREFIX'), ''));
    } else if(isProductIdBarcode) {
      selectProductFullId(safePrefix(barcodeValue));
      setTenantNumber(safePrefix(barcodeValue).match(new RegExp(`${env('TENANT_PREFIX')}([^-]+)`))[1]);
    } else {
      selectProductFullId('');
      setTenantNumber('');
    }
  }, [barcodeValue, janMatchedProducts]);
  useEffect(() => {
    if(!!inputtedDocumentNumber && filteredDocumentNumberMatchedReceivingRequests.length > 0 && candidateReceivingRequestItems.every(_ => _.isAllReceived)) {
      setBarcodeValue('');
      barcodeValueInput.current.focus();
    }
  }, [inputtedDocumentNumber, documentNumberMatchedReceivingRequests]);
  useEffect(() => {
    selectShippingSize(conclusiveProduct?.shippingSize || null);
  }, [conclusiveProduct?.id]);

  // DEV
  //  useEffect(() => {
  //    if(conclusiveProduct) {
  //      const canvas = document.getElementById('canvas');
  //      (conclusiveProduct.isAmazonProduct ? drawAmazonProductLabel : drawProductLabel)(canvas, labelWidth, labelHeight, conclusiveProduct);
  //    }
  //  }, [conclusiveProduct]);
  const onClickClose = () => {
    const message = dedent`
      ラベルを発行した場合は「入荷検品完了」から入荷検品を完了させてください。
      本当にこの画面を閉じますか？
    `;
    if(hasPrintedBarcode && !window.confirm(message)) return;

    props.onClickClose();
  };
  const processUnknownNewValues = async (values) => {
    const [processedSlipImages, processedJanImages] = await Promise.all(['slipImages', 'janImages'].map(async (imagesName) => {
      return await Promise.all(Array.from(values[imagesName] || []).map(async (file) => {
        const path = `tenants/${values.tenantId}/receivingRequests/${values.id}/${imagesName}/${(new Date()).getTime()}`;
        const fileRef = storageRef.child(path);
        await fileRef.put(file, { contentType: file.type });
        const downloadUrl = await fileRef.getDownloadURL();
        return {
          uploadedAt: new Date(),
          downloadUrl,
          storagePath: path,
          ...pick(file, ['name', 'type']),
        };
      }));
    }));
    return {
      ...omit(values, 'tenantId'),
      items: [],
      productIds: [],
      slipImages: processedSlipImages,
      janImages: processedJanImages,
    };
  };

  return (
    <Modal isOpen={isOpen} style={{ minWidth: !isMobile() && 600 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            入荷検品
          </h5>
          <div className="d-flex gap-1">
            <div style={{ width: 200 }}>
              <Select
                options={printerOptions}
                value={printerOptions.find(_ => _.value === currentPrinterId)}
                onChange={_ => selectPrinterId(_?.value)}
                className="w-100"
              />
            </div>
            <AddButton label="不明入庫" itemRef={newUnknownReceivingRequestRef} FormModal={UnknownReceivingRequestFormModal} validateOnSubmit={_ => _.id !== 'W1' || window.confirm('W1を作ることになります。よろしいですか？')} processValues={processUnknownNewValues} formProps={{ values: null, tenants, }} onFinish={_ => [window.alert(idWithTenant(_.ref)), setUnknownReceivingRequest(_), toggleUnknownShelvingModal(true)]} />
          </div>
        </div>
      </div>
      <ModalBody>
        {
          // DEV
          // <canvas className="border" id="canvas" width={500} height={400} />
        }
        <FormGroup>
          <Label>伝票番号または商品ラベルまたはFNSKUまたはJANコード</Label>
          <Input innerRef={barcodeValueInput} value={barcodeValue} onChange={_ => setBarcodeValue(_.target.value)} type="url" />
        </FormGroup>
        {
          filteredDocumentNumberMatchedReceivingRequests.length === 0 && (
            <FormGroup className="d-flex align-items-center">
              <InputGroup>
                <div className="input-group-prepend">
                  <span className="input-group-text">{env('TENANT_PREFIX')}</span>
                </div>
                <Input value={tenantNumber} onChange={_ => setTenantNumber(_.target.value)} type="tel" />
              </InputGroup>
              <div className="mx-2">-</div>
              <InputGroup>
                <div className="input-group-prepend">
                  <span className="input-group-text">W</span>
                </div>
                <Input value={receivingRequestNumber} onChange={_ => setReceivingRequestNumber(_.target.value)} type="tel" />
              </InputGroup>
            </FormGroup>
          )
        }
        {
          candidateReceivingRequests.length > 0 && (
            <div>
              <FormGroup>
                <Label>商品バーコード</Label>
                <Input value={productBarcodeInfoValue} {...inputtedDocumentNumber && !isEmpty(documentNumberMatchedReceivingRequests) && { autoFocus: true }} onChange={_ => setProductBarcodeInfoValue(_.target.value)} type="url" />
              </FormGroup>
              {
                barcodeMatcedProduct == null && (
                  <Fragment>
                    <FormGroup>
                      <Label>商品ID、SKUで検索</Label>
                      <Select
                        options={productOptions}
                        value={productOptions.find(_ => _.value === selectedProductFullId) || null}
                        onChange={_ => selectProductFullId(_ && _.value)}
                        className="w-100"
                        styles={{ 
                          valueContainer: _ => ({ ..._, height: 60 }),
                          singleValue: _ => ({ ..._, top: 0, transform: '' }),
                        }}
                        filterOption={({ data }, query) => ['id', 'sku'].some(_ => (data[_] || '').match(query))}
                        isClearable
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>商品名で検索</Label>
                      <Select
                        options={productOptions}
                        value={productOptions.find(_ => _.value === selectedProductFullId) || null}
                        onChange={_ => selectProductFullId(_ && _.value)}
                        className="w-100"
                        styles={{ 
                          valueContainer: _ => ({ ..._, height: 60 }),
                          singleValue: _ => ({ ..._, top: 0, transform: '' }),
                        }}
                        filterOption={({ data }, query) => ['name'].some(_ => (data[_] || '').match(query))}
                        isClearable
                      />
                    </FormGroup>
                  </Fragment>
                )
              }
            </div>
          )
        }
        {
          barcodeMatcedProduct != null && (
            <div className="card">
              <div className="card-header">
                見つかった商品
              </div>
              <div className="card-body">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th className="table-secondary text-nowrap">商品ID</th>
                      <td>{idWithTenant(barcodeMatcedProduct.ref)}</td>
                    </tr>
                    <tr>
                      <th className="table-secondary text-nowrap">商品名</th>
                      <td>{barcodeMatcedProduct.name}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )
        }
        {
          conclusiveProduct != null && (
            <div>
              <div className="mt-2 d-flex align-items-center">
                <Input type="number" className="text-right" step="1" value={quantity} onChange={_ => setQuantity(parseInt(_.target.value, 10))} style={{ width: 'auto' }} />
                {
                  (conclusiveProduct.isAmazonProduct && !conclusiveProduct.isCase) ? (
                    isEmpty(conclusiveProduct.fnsku) ? (
                      conclusiveProduct.createdAt.toDate() < addHours(new Date(), -5) ? (
                        <Button className="ml-2" onClick={onClickPrintBarcode.bind(null, false)} disabled={isPrinting || !(0 < quantity && quantity < 10000)}>
                          {isPrinting && <span className="fas fa-spin fa-spinner mr-1" />}
                          商品IDラベル発行 (FNSKU取得失敗)
                        </Button>
                      ) : (
                        <span className="ml-2 text-danger">FNSKU取得中です</span>
                      )
                    ) : (
                      <Button className="ml-2" onClick={onClickPrintBarcode.bind(null, false)} disabled={isPrinting || !(0 < quantity && quantity < 10000)}>
                        {isPrinting && <span className="fas fa-spin fa-spinner mr-1" />}
                        FNSKUラベル発行
                      </Button>
                    )
                  ) : (
                    <Button className="ml-2" onClick={onClickPrintBarcode.bind(null, false)} disabled={barcodeValue?.includes('-') || isPrinting || !(0 < quantity && quantity < 10000)}>
                      {isPrinting && <span className="fas fa-spin fa-spinner mr-1" />}
                      商品IDラベル発行
                    </Button>
                  )
                }
                <Button className="ml-2" onClick={onClickPrintBarcode.bind(null, true)} disabled={isPrinting || !(0 < quantity && quantity < 10000)}>
                  {isPrinting && <span className="fas fa-spin fa-spinner mr-1" />}
                  販売不可ラベル発行
                </Button>
                <div className="ml-2">
                  {
                    (conclusiveProduct.isAmazonProduct && !conclusiveProduct.isCase) && (
                      <span className={classnames('fas fa-cat cursor-pointer', { 'text-info': conclusiveProduct.isNeko, 'text-muted': !conclusiveProduct.isNeko })} onClick={onClickNeko} />
                    )
                  }
                  {!conclusiveProduct.isNeko && conclusiveProduct.requestsNeko && <span className="text-danger">ネコポス希望</span>}
                </div>
              </div>
              {
                isNg && (
                  <div className="mt-2">
                    <Input type="file" accept="image/*" onChange={_ => setFiles(get(_, 'target.files'))} />
                  </div>
                )
              }
              <div className="mt-2 d-flex align-items-center gap-2">
                <div style={{ width: 200 }}>
                  <Select
                    options={conclusiveProduct.isAmazonProduct && !conclusiveProduct.isCase ? shippingSizeOptions.filter(_ => _.value === 'neko') : shippingSizeOptions}
                    value={shippingSizeOptions.find(_ => _.value === shippingSize)}
                    onChange={_ => selectShippingSize(_?.value)}
                    className="w-100"
                    placeholder="サイズ選択"
                    isClearable
                  />
                </div>
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" checked={isOpp} onChange={_ => toggleOpp(_.target.checked)} />
                    OPP梱包あり
                  </Label>
                </FormGroup>
              </div>
              <div className="mt-2 d-flex align-items-center gap-2">
                <FormGroup tag="fieldset" className="m-0">
                  <div className="form-inline">
                    <span className="mr-2">セット:</span>
                    {
                      setSizeOptions.map(({ label, value, }) => (
                        <FormGroup check key={value} className="mr-2">
                          <Label check>
                            <Input type="radio" checked={value === setSize} onChange={_ => setSetSize(value)} />
                            {label}
                          </Label>
                        </FormGroup>
                      ))
                    }
                  </div>
                </FormGroup>
                {setSize && setSize !== 'none' && <Input type="number" className="text-right" step="1" value={quantityOfSet} onChange={_ => setQuantityOfSet(parseInt(_.target.value, 10))} style={{ width: 'auto' }} />}
              </div>
              <div className="mt-1">
                <span>期限:</span>
                <DatePicker
                  dateFormat="yyyy/MM/dd"
                  selected={expirationDate}
                  onChange={_ => setExpirationDate(_)}
                  isClearable
                />
              </div>
            </div>
          )
        }
        {
          candidateReceivingRequests.length > 0 && (
            <div className="mt-2">
              <hr />
              <h5>
                入荷依頼の候補
              </h5>
              {
                conclusiveProduct != null && (() => {
                  const totalReceivedCount = conclusiveReceivingRequests.reduce((x, receivingRequest) => {
                    const targetItem = candidateReceivingRequestItems.find(_ => _.receivingRequest === receivingRequest && _.productId === conclusiveProduct.id);
                    return x + (targetItem?.receivedCount || 0);
                  }, 0);
                  const totalQuantity = conclusiveReceivingRequests.reduce((x, receivingRequest) => {
                    const targetItem = candidateReceivingRequestItems.find(_ => _.receivingRequest === receivingRequest && _.productId === conclusiveProduct.id);
                    return x + (targetItem?.quantity || 0);
                  }, 0);
                  return (
                    <div className="mb-2 p-2 bg-light border rounded">
                      <strong>合計:</strong> 検品数 {totalReceivedCount} / 依頼数 {totalQuantity}
                    </div>
                  );
                })()
              }
              <div>
                <table className="table table-bordered table-sm" style={{ fontSize: isMobile() && '80%' }}>
                  <thead className="thead-light text-nowrap">
                    <tr>
                      <th style={{ minWidth: isMobile() ? 50 : 80 }}>入荷依頼ID</th>
                      <th style={{ minWidth: isMobile() ? 50 : 80 }}>
                        {
                          isMobile() ? (
                            <div>検品数/<br />依頼数</div>
                          ) : '検品数/依頼数'
                        }
                      </th>
                      <th style={{ minWidth: isMobile() ? 50 : 70 }}>オプション</th>
                      <th style={{ minWidth: isMobile() ? 50 : 70 }}>検品内容</th>
                      <th style={{ minWidth: isMobile() ? 50 : 70 }}>セット内容</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      conclusiveReceivingRequests.map((receivingRequest) => {
                        const { id, ref, documentNumber = null, checkNote = '', setNote = '', status, receivingOptionValues = [], } = receivingRequest;
                        const items = candidateReceivingRequestItems.filter(_ => _.receivingRequest === receivingRequest);
                        const targetItem = items.find(_ => _.productId === get(conclusiveProduct, 'id'));
                        const onClickReceived = async () => {
                          const inventoryType = isNg ? 'ng' : 'good';
                          const inventoryIdsFieldName = inventoryType + 'ReceivedInventoryIds';
                          const inventoryRefs = Array(quantity).fill().map(_ => inventoriesRef.doc());
                          try {
                            const _batch = db.batch();
                            _batch.set(ref, {
                              ...(
                                setSize && setSize !== 'none' && {
                                  setQuantities: {
                                    [setSize]: firebase.firestore.FieldValue.increment(quantityOfSet),
                                  },
                                }
                              ),
                              ...(
                                !['processing', 'received'].includes(status) && {
                                  status: 'processing',
                                }
                              ),
                              ...(
                                inputtedDocumentNumber && {
                                  receivementDocumentNumbers: firebase.firestore.FieldValue.arrayUnion(inputtedDocumentNumber),
                                }
                              ),
                              ...(
                                isNg && await (async () => {
                                  const [file] = files;
                                  const path = `tenants/${ref.parent.parent.id}/receivingRequests/${id}/ngFileDownloadUrls/${conclusiveProduct.id}/${(new Date()).getTime()}`;
                                  const fileRef = storageRef.child(path);
                                  await fileRef.put(file, { contentType: file.type });
                                  const downloadUrl = await fileRef.getDownloadURL();
                                  return {
                                    [`ngFileDownloadUrls_${conclusiveProduct.id}`]: firebase.firestore.FieldValue.arrayUnion(downloadUrl),
                                  }
                                })()
                              ),
                              [[inventoryIdsFieldName, conclusiveProduct.id].join('-')]: firebase.firestore.FieldValue.arrayUnion(...inventoryRefs.map(_ => _.id)),
                            }, { merge: true });

                            // NOTE 請求ログ関連
                            if(setSize && setSize !== 'none') {
                              _batch.set(billingLogsRef.doc(), {
                                type: 'receivingRequestSetsCount',
                                tenantId: ref.parent.parent.id,
                                payload: { receivingRequestId: id, setSize, quantityOfSet, },
                                createdAt: new Date(),
                              });
                            }
                            if(isOpp) {
                              _batch.set(billingLogsRef.doc(), {
                                type: 'receivingRequestOppsCount',
                                tenantId: ref.parent.parent.id,
                                payload: { receivingRequestId: id, quantity, },
                                createdAt: new Date(),
                              });
                            }
                            if(receivingOptionValues.includes('check')) {
                              _batch.set(billingLogsRef.doc(), {
                                type: 'receivingRequestCheckCounts',
                                tenantId: ref.parent.parent.id,
                                payload: { receivingRequestId: id, quantity, },
                                createdAt: new Date(),
                              });
                            }
                            if(receivingOptionValues.includes('keepDocuments') && !receivingRequest.hasLogKeepDocuments) {
                              _batch.set(billingLogsRef.doc(), {
                                type: 'receivingRequestKeepDocumentsCount',
                                tenantId: ref.parent.parent.id,
                                payload: { receivingRequestId: id, quantity: 1, },
                                createdAt: new Date(),
                              });
                              _batch.update(ref, { hasLogKeepDocuments: true, });
                            }
                            if(!receivingRequest.hasLogReceiving) {
                              _batch.set(billingLogsRef.doc(), {
                                type: 'receivingCount',
                                tenantId: ref.parent.parent.id,
                                payload: { receivingRequestId: id, hasDocumentNumber: !isEmpty(documentNumber), quantity: 1, },
                                createdAt: new Date(),
                              });
                              _batch.update(ref, { hasLogReceiving: true, });
                            }

                            if(shippingSize != null) {
                              _batch.update(conclusiveProduct.ref, {
                                shippingSize,
                                storageSize: shippingSize,
                                ...(shippingSize === 'neko' && { isNeko: true }),
                              });
                            }
                            if(expirationDate != null) {
                              _batch.update(conclusiveProduct.ref, {
                                hasExpiration: true,
                              });
                            }
                            await batch(db, inventoryRefs, (batch, ref) => {
                              batch.set(ref, {
                                tenantId: conclusiveProduct.ref.parent.parent.id,
                                receivingRequestId: id,
                                receivingRequestDocumentNumber: documentNumber,
                                receivingRequestCheckNote: checkNote,
                                productId: conclusiveProduct.id,
                                productBarcodeInfo: isNg ? (
                                  idWithTenant(conclusiveProduct.ref) + '-N'
                                ) : janMatchedProducts.length > 0 ? (
                                  conclusiveProduct.barcodeInfo
                                ) : (
                                  labelString(conclusiveProduct)
                                ),
                                productBarcodeInfoType: (conclusiveProduct.isAmazonProduct && conclusiveProduct.fnsku && !isNg) ? (
                                  'fnsku'
                                ) : janMatchedProducts.length > 0 ? (
                                  'jan'
                                ) : (
                                  'id'
                                ),
                                wasNoFnsku: !!conclusiveProduct.isAmazonProduct && isEmpty(conclusiveProduct.fnsku),
                                locationId: null,
                                status: 'received',
                                isNg,
                                expirationDate,
                                createdAt: new Date(),
                              });
                            }, 489, { firstBatch: _batch });
                            toast.success(`入荷検品済にしました`);
                            setTenantNumber('');
                            setExpirationDate(null);
                            setReceivingRequestNumber('');
                            setProductBarcodeInfoValue('');
                            selectProductFullId(null);
                            selectShippingSize(null);
                            togglePrintedBarcode(false);
                            if(!inputtedDocumentNumber) {
                              setBarcodeValue('');
                              barcodeValueInput.current.focus();
                            }
                            toggleNg(false);
                            setQuantity(1);
                            setSetSize('none');
                            toggleOpp(false);
                            setFiles(null);
                            setQuantityOfSet(1);
                            updateVersion();
                          } catch(e) {
                            console.error(e);
                            toast.error('失敗しました');
                          }
                        }
                        const processValues = (values) => {
                          return {
                            ...values,
                            productIds: values.items.map(_ => _.productId),
                            ...(status !== 'received' && values.status === 'received' && { completedAt: new Date() }),
                          };
                        };

                        return (
                          <tr key={id}>
                            <td>
                              <div className={classnames({ 'text-nowrap': !isMobile() })}>
                                <ReceivingRequestDetailLink receivingRequest={receivingRequest} />
                                <EditButton itemRef={ref} processValues={processValues} FormModal={ReceivingRequestFormModal} formProps={{ tenant: tenantsById[ref.parent.parent.id], admin: true }} size="sm" color="link" onFinish={updateVersion} label={false} />
                              </div>
                              <ProgressButton size="sm" color="primary" className="" process={onClickReceived} disabled={!hasPrintedBarcode || (isNg && isEmpty(files)) || setSize == null || !(quantityOfSet > 0) || (quantity > targetItem?.unreceivedCount)}>
                                {isNg && <span>販売不可で</span>}
                                入荷検品完了
                              </ProgressButton>
                            </td>
                            <td className="text-right">
                              {
                                conclusiveProduct != null && (
                                  <div>{targetItem?.receivedCount}/{targetItem?.quantity}</div>
                                )
                              }
                            </td>
                            <td>
                              {fieldDisplayValue(receivingOptionValues, fields().receivingOptionValues)}
                            </td>
                            <td>
                              <div className="text-danger" style={{ whiteSpace: 'pre-line', }}>
                                {checkNote}
                              </div>
                            </td>
                            <td>
                              <div className="text-danger" style={{ whiteSpace: 'pre-line', }}>
                                {setNote}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          )
        }
      </ModalBody>
      <ModalFooter>
        {!hasPrintedBarcode && <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>}
      </ModalFooter>
      {showsUnknownShelvingModal && <UnknownLabelModal isOpen {...{ tenants, locations, unknownReceivingRequest, }} onClickClose={toggleUnknownShelvingModal.bind(null, false)} />}
    </Modal>
  );
};

function ReceivingRequestDetailLink(props) {
  const { receivingRequest } = props
  const { ref } = receivingRequest;
  const [showsModal, toggleModal] = useToggle(false);
  const onClickId = (e) => {
    e.preventDefault();
    toggleModal(true);
  };

  return (
    <Fragment>
      <Link onClick={onClickId}>
        {idWithTenant(ref)}
      </Link>
      {showsModal && <ReceivingRequestDetailModal isOpen receivingRequest={receivingRequest} onClickClose={toggleModal.bind(null, false)} />}
    </Fragment>
  );
}
